export { default } from "./enum-label";
